var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 60,
    viewBox: "0 0 116 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3636 60C74.3636 50.6514 67.039 43.0759 58.013 43.0759C48.974 43.0759 41.6493 50.6514 41.6493 59.9866H0C0 26.8502 25.987 -0.0134268 58.013 5.03474e-06C90.039 0.0134369 116.013 26.8771 116 60",
    fill: "#EA6AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4804 38.4414L31.2856 43.3709L30.3765 45.2916L20.5713 40.3622L21.4804 38.4414Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4285 32.9748L27.2597 29.7512C29.4804 27.1454 32.8181 26.9977 35.1038 29.2005C37.4545 31.3361 37.6363 34.7881 35.3376 37.3267L32.5064 40.5504L24.4155 32.9614L24.4285 32.9748ZM33.7792 36.1716C35.4025 34.318 35.2597 32.3167 33.6883 30.8392C32.1168 29.3617 30.1558 29.402 28.5324 31.2421L27.2467 32.7062L32.4934 37.6222L33.7792 36.1582V36.1716Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5322 18.4014L43.4153 20.1609L38.7789 22.6458L39.9478 24.983L44.1815 22.713L45.0517 24.4457L40.8179 26.7157L42.0387 29.1468L46.675 26.6619L47.5582 28.4215L41.1036 31.8869L36.0776 21.8802L42.5322 18.4148V18.4014Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9609 20.1072L51.7661 27.2932L49.7271 27.535L48.4414 16.2388L49.6232 16.0911L56.6622 22.619L55.857 15.4329L57.9089 15.1777L59.1947 26.4739L58.0258 26.6217L50.9739 20.0938L50.9609 20.1072Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1948 17.5279L63.6364 15.6475L72.0649 17.7966L71.6234 19.677L68.4156 18.8577L66.2468 27.9376L64.2468 27.4272L66.4156 18.3473L63.1948 17.5279Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1558 20.9263L73.0519 30.8928L71.2207 29.8854L76.3246 19.9189L78.1558 20.9263Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.052 24.8356L82.2987 23.3984L88.7403 29.4159L87.4935 30.8531L85.039 28.5697L78.987 35.514L77.4546 34.0902L83.5065 27.1459L81.039 24.8491L81.052 24.8356Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5845 40.3897L93.9221 41.3702L91.3507 36.6691L89.1429 37.9585L91.4936 42.2567L89.8572 43.2104L87.5065 38.9122L85.1949 40.2554L87.7663 44.9565L86.104 45.937L82.5195 39.3823L92.013 33.835L95.5975 40.3897H95.5845ZM96.7793 35.5408L97.9741 37.7302L95.104 37.2869L94.3507 35.9035L96.7923 35.5542L96.7793 35.5408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.cdd63797636dd450f8571fe265665717.svg";
export { ForwardRef as ReactComponent };